import { render } from "./NotesView.vue?vue&type=template&id=3f4be1c4&scoped=true"
import script from "./NotesView.vue?vue&type=script&lang=js"
export * from "./NotesView.vue?vue&type=script&lang=js"

import "./NotesView.vue?vue&type=style&index=0&id=3f4be1c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4be1c4"]])

export default __exports__